<script>
  import { onMount } from 'svelte';

  export let iconSrc = '';
  export let prefix = '';
  export let value = '';
  export let suffix = '';
  export let label = [];

  const target = parseInt(String(value).replace(/\D/g, ''), 10);
  const animate = !Number.isNaN(target) && target > 0;
  let displayed = animate ? 0 : value;
  let el;

  onMount(() => {
    if (!animate || typeof IntersectionObserver === 'undefined') {
      displayed = value;
      return;
    }
    if (typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches) {
      displayed = value;
      return;
    }
    const observer = new IntersectionObserver(
      (entries, obs) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            startCount();
            obs.disconnect();
          }
        }
      },
      { threshold: 0.4 }
    );
    if (el) observer.observe(el);
    return () => observer.disconnect();
  });

  function startCount() {
    const duration = 1500;
    const start = performance.now();
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      displayed = Math.round(target * eased);
      if (t < 1) requestAnimationFrame(tick);
      else displayed = value;
    };
    requestAnimationFrame(tick);
  }
</script>

<div class="about-stat-card" bind:this={el}>
  <img class="stat-icon" src={iconSrc} alt="" aria-hidden="true">

  <div class="stat-copy">
    <div class="stat-value" aria-label={`${prefix ? `${prefix} ` : ''}${value}${suffix}`}>
      {#if prefix}
        <span class="stat-prefix">{prefix}</span>
      {/if}
      <span class="stat-number">{displayed}</span>
      {#if suffix}
        <span class="stat-suffix">{suffix}</span>
      {/if}
    </div>

    <span class="stat-label">
      {#each label as line}
        <span>{line}</span>
      {/each}
    </span>
  </div>
</div>

<style>
  .about-stat-card {
    display: flex;
    min-height: 208px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    padding: 20px 40px;
    color: #ffffff;
    text-align: center;
    text-transform: uppercase;
    box-sizing: border-box;
  }

  .stat-icon {
    display: block;
    width: auto;
    height: 56px;
    max-width: 107px;
    object-fit: contain;
  }

  .stat-copy {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 13px;
  }

  .stat-value {
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 2px;
    line-height: 1;
    white-space: nowrap;
  }

  .stat-prefix {
    font-size: 20px;
    font-weight: 700;
    line-height: 1.5;
  }

  .stat-number {
    font-size: 56px;
    font-weight: 400;
    line-height: 1;
    letter-spacing: 0;
  }

  .stat-suffix {
    font-size: 40px;
    font-weight: 400;
    line-height: 1;
  }

  .stat-label {
    display: flex;
    flex-direction: column;
    gap: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 1.4px;
  }

  @media (max-width: 1279px) {
    .about-stat-card {
      min-height: 221px;
      padding: 20px 24px;
    }
  }

  @media (max-width: 767px) {
    .about-stat-card {
      min-height: 202px;
      padding: 20px 8px;
    }
  }
</style>
